import { TextRegular } from 'UiKit/typography';

import ActionButton from 'View/report-attendance/component/action-button';
import ColumnHostName from 'View/report-attendance/component/column-host-name';
import ColumnContent from 'View/report-attendance/component/column-content';

import styles from './styles.module.css';

export const tableListOperator = [
  {
    name: 'Nama Operator',
    width: 200,
    key: 'operatorName',
    component: ({ value }) => <TextRegular className={`${styles['column__text']} ${styles['column__text--truncate']}`}>{value}</TextRegular>,
  },
  {
    name: 'Periode Laporan',
    width: 200,
    key: 'reportPeriod',
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: 'Total Hari Bekerja',
    width: 200,
    key: 'totalWorkDays',
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: 'Total Pelanggaran Istirahat',
    width: 200,
    key: 'totalBreakViolations',
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: 'Total Telat Clock-in',
    width: 200,
    key: 'totalLateClockIn',
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: 'Pelanggaran Absen Kamera',
    width: 200,
    key: 'totalCameraViolations',
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: 'Total Pelanggaran',
    width: 200,
    key: 'totalViolations',
    component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
  },
  {
    name: 'Action',
    width: 150,
    position: 'center',
    rightSticky: 0,
    component: ({ values }) => <ActionButton values={values} isOperator={true} />,
  },
];

export const tableListHost = ({ t }) => {
  return [
    {
      name: t('tableColumnHost.hostName'),
      width: 200,
      key: 'hostName',
      component: ({ values }) => <ColumnHostName values={values} />,
    },
    {
      name: t('tableColumnHost.totalLiveSessionsText'),
      width: 140,
      key: 'totalStreamingSessions',
      component: ({ value }) => <TextRegular className={styles['column-host__text']}>{value}</TextRegular>,
    },
    {
      name: t('tableColumnHost.totalWorkingDays'),
      width: 160,
      key: 'totalWorkingDays',
      component: ({ value }) => <TextRegular className={styles['column-host__text']}>{value}</TextRegular>,
    },
    {
      name: t('tableColumnHost.totalLateClockIn'),
      width: 165,
      key: 'totalLateClockIn',
      component: ({ value }) => <TextRegular className={styles['column-host__text']}>{value}</TextRegular>,
    },
    {
      name: t('tableColumnHost.totalLateSession'),
      width: 140,
      key: 'totalLateStreamingSessions',
      component: ({ value }) => <TextRegular className={styles['column-host__text']}>{value}</TextRegular>,
    },
    {
      name: t('tableColumnHost.totalLivestreamHours'),
      width: 155,
      key: 'totalLivestreamHours',
      component: ({ value }) => <TextRegular className={styles['column-host__text']}>{value}</TextRegular>,
    },
    {
      name: t('tableColumnHost.totalWorkingHours'),
      width: 140,
      key: 'totalWorkingHours',
      component: ({ value }) => <TextRegular className={styles['column-host__text']}>{value}</TextRegular>,
    },
    {
      name: t('tableColumnHost.totalContent'),
      width: 140,
      key: 'totalTasks',
      component: ({ values }) => <ColumnContent values={values} t={t} />,
    },
    {
      name: 'Action',
      width: 150,
      position: 'center',
      rightSticky: 0,
      component: ({ values }) => <ActionButton values={values} isOperator={false} />,
    },
  ];
};
